import { z } from "zod/v4";

import { ExperiencePageTargetingDtoSchema } from "../../../../dtos/experience-page-targeting";

export const PluginExperiencePageTargetingSchema_2024_05_05 =
  ExperiencePageTargetingDtoSchema;
export type PluginExperiencePageTargetingType_2024_05_05 = z.infer<
  typeof PluginExperiencePageTargetingSchema_2024_05_05
>;
